// Environment variable strings passed in from docker-compose command.
export const serverUrl = 'https://api-staging-angel-e2.azurewebsites.net/api/'
export const redirectUrl = 'https://angel-staging.azurewebsites.net/'
export const azureMapsApiKey = 'FMG4SRqJhWH0ix1NBc7lvPLIKxOtE_qrNpFbo078fgg'
export const pendoStatus = 'true'
export const timeout = '10000'
export const parcelApiKey = 'zzQmguu7mQ'
